import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


  export default function Praca({praca, setPraca} ){

    const { globalSearch } = useZamowienia();
    const handleSubmit = (event) => {
    event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
    globalSearch();
  };

  return(
      <form onSubmit={handleSubmit} className={styles.colData}>

      <label className={styles.labelData}> Tytul </label>
      <input className={styles.inputData} type="text"
      value={praca}
      onChange={(event) => {
        

         const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻŚĆŹ.-/-ŠšŽžČčĐđ,!:]+$/;
        setPraca(event.target.value);
         

      }}></input>
    </form>
  );
}